import styles from "./Hero.module.less";

export const HeroColWrapper = ({ children }) => {
  return <div className={styles.HeroColWrapper}>{children}</div>;
};
